import { z } from "zod";
export const automationRefSchema = z
    .object({
    kind: z.enum(["opportunity", "lead", "booking", "order"]),
    id: z.string().min(1).max(191),
})
    .strict();
export const automationTreatments = [
    "unclassified",
    "informational",
    "sales_interest",
];
export const automationInquiryStates = ["open", "attended"];
export const automationTreatmentUpdateSchema = z
    .object({
    commandId: z.string().uuid(),
    expectedVersion: z.number().int().nonnegative(),
    contextFingerprint: z.string().min(1).max(128),
    action: z.enum(["informational", "sales_interest", "attend", "reopen"]),
})
    .strict();
export const automationClassificationSuggestionSchema = z
    .object({
    classification: z.enum(["informational", "sales_interest", "uncertain"]),
    inquiryState: z.enum(["answered", "unanswered", "uncertain"]),
    reason: z.string().min(1).max(700),
    sourceIds: z.array(z.string().min(1).max(210)).min(1).max(20),
})
    .strict();
export const automationServices = ["balloon", "tour", "school"];
export const automationCategories = [
    "inquiry",
    "followup",
    "proposal",
    "balance",
    "preparation",
    "document",
    "closure",
    "postvisit",
];
export const automationStatuses = [
    "pending",
    "snoozed",
    "completed",
    "dismissed",
    "resolved",
];
export const automationCommandSchema = z
    .object({
    commandId: z.string().uuid(),
    expectedVersion: z.number().int().nonnegative(),
})
    .strict();
export const automationTaskUpdateSchema = automationCommandSchema
    .extend({
    action: z.enum(["complete", "dismiss", "snooze"]),
    snoozedUntil: z.string().datetime({ offset: true }).optional(),
    title: z.string().trim().min(1).max(250).optional(),
    note: z.string().max(2000).optional(),
})
    .strict();
export const automationDraftUpdateSchema = automationCommandSchema
    .extend({
    action: z.enum(["save", "review", "discard"]),
    body: z.string().trim().min(1).max(4000).optional(),
    caseRef: automationRefSchema.optional(),
})
    .strict();
export const automationViewSchema = automationCommandSchema
    .extend({
    name: z.string().trim().min(1).max(80),
    section: z.enum(["attention", "pipeline", "agenda"]),
    service: z.enum(automationServices).nullable(),
    layout: z.enum(["list", "board"]),
    filters: z
        .object({
        category: z.enum(automationCategories).optional(),
        status: z.enum(automationStatuses).optional(),
        priority: z.number().int().min(0).max(3).optional(),
        stage: z
            .enum(["new", "conversation", "quote", "awaiting", "won", "lost"])
            .optional(),
        search: z.string().trim().max(190).optional(),
        treatment: z.enum(automationTreatments).optional(),
        inquiryState: z.enum(automationInquiryStates).optional(),
        salesEligible: z.boolean().optional(),
    })
        .strict(),
    archived: z.boolean(),
})
    .strict();
export const automationAdviceSchema = z
    .object({
    summary: z.string().min(1).max(1000),
    nextAction: z.string().min(1).max(500),
    reason: z.string().min(1).max(700),
    missingFacts: z.array(z.string().min(1).max(250)).max(10),
    draft: z.string().max(2000),
    sourceIds: z.array(z.string().min(1).max(210)).min(1).max(20),
    followupDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .nullable(),
    followupSourceId: z.string().max(210).nullable(),
    reviewNeeded: z.boolean(),
    classificationSuggestion: automationClassificationSuggestionSchema,
})
    .strict();
export { automationRules, automationEvidence, mexicoDate, followupPromise, validateAutomationAdvice, automationTreatment, isInquiryAcknowledgement, salesFollowupEligible, } from "./crm-automation-rules.js";
